module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-SemiboldCond.aeb4dfa.ttf";